exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-article[data-v-421505fd] {\n  margin: -38px -15px 0;\n  background-size: contain;\n  background-position: top center;\n  background-image: url(\"/public/betsur/bg.png\");\n  min-height: 690px;\n  padding: 120px 0 55px;\n}\n.page-article .container[data-v-421505fd] {\n  max-width: 882px !important;\n}", ""]);

// exports
